var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftIcon = function SvgArrowLeftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.015 16.023a.5.5 0 0 1-.707-.007l-2.91-2.966a1.5 1.5 0 0 1 0-2.1l2.91-2.966a.5.5 0 0 1 .714.7l-2.91 2.966a.5.5 0 0 0 0 .7l2.91 2.966a.5.5 0 0 1-.007.707",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeftIcon;